import React from 'react';
import { Editor } from '@tinymce/tinymce-react';

const Advanced = ({ editorRef }) => {


    return (
        <div>
            <Editor

                apiKey='4rrlkexc07nxzat6bvzcywwrwzjjlurw4hzpunmtqyaz4yel'

                onInit={(evt, editor) => (editorRef.current = editor)}
                init={{
                    height: 600,
                    plugins: [
                        'advlist', 'autolink', 'link', 'image', 'lists', 'charmap', 'preview', 'anchor', 'pagebreak',
                        'searchreplace', 'wordcount', 'visualblocks', 'code', 'fullscreen', 'insertdatetime', 'media',
                        'table', 'emoticons'
                    ],
                    toolbar: 'undo redo | styles | bold italic | alignleft aligncenter alignright alignjustify | ' +
                        'bullist numlist outdent indent | link image | print preview media fullscreen | ' +
                        'forecolor backcolor emoticons | help',
                    menu: {
                        favs: { title: 'Color Bot Menu', items: 'code visualaid | searchreplace | emoticons' }
                    },
                    menubar: 'favs file edit view insert format tools table help',
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:16px }'
                }}

            />

        </div>
    );
};

export default Advanced;
